























/* General */
import Vue from 'vue'
import MailboxSettingsLayout from '@/layouts/mailbox-settings-layout.vue'

/* Mixins */

/* Components */
import EntitySettingsLoading from '@/layouts/entity-settings-loading.vue'

/* Helpers */

/* Data types */
import { IPersonBase } from '@/api/types/response.types'
import { EEntities } from '@/types'

/* API */

export default Vue.extend({
  name: 'MailboxSettingsAssignPeople',

  metaInfo(): any {
    return {
      title: `Add/Remove User - ${this.name}`,
    }
  },

  components: {
    MailboxSettingsLayout,
    EntitySettingsLoading,
  },

  data() {
    return {
      EEntities,
      name: '',
      assignedPeople: [] as IPersonBase[],
    }
  },

  computed: {
    id(): number {
      return parseInt(this.$route.params.id, 10)
    },
  },
})
